(function () {
  'use strict';
  if (window.bloomingfulGreeneryBoxLoaded) return;
  window.bloomingfulGreeneryBoxLoaded = true;
  function initialize(root) {
    if (root.dataset.initialized) return;
    var form = root.closest('form.bf-custom-greenery-form');
    if (!form) return;
    root.dataset.initialized = 'true';
    var inputs = Array.from(root.querySelectorAll('[data-bf-greenery-count]'));
    var properties = root.querySelector('[data-bf-greenery-properties]');
    var error = root.querySelector('[data-bf-greenery-error]');
    var totalNode = root.querySelector('[data-bf-greenery-total]');
    var lastSignature = '';
    var syncing = false;
    inputs.forEach(function (input) { input.disabled = input.dataset.soldOut === 'true'; });
    function selection() {
      var total = 0;
      var rows = [];
      var invalid = null;
      inputs.forEach(function (input) {
        var value = input.value.trim() === '' ? 0 : Number(input.value);
        if (input.validity.badInput || !Number.isSafeInteger(value) || value < 0 || (input.disabled && value !== 0)) {
          invalid = invalid || input;
          return;
        }
        if (value) {
          total += value;
          rows.push({ input: input, quantity: value });
        }
      });
      if (!Number.isSafeInteger(total)) invalid = invalid || inputs[0];
      return { total: total, rows: rows, invalid: invalid };
    }
    function property(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.value = value;
      properties.appendChild(input);
    }
    function quantityControls() {
      return Array.from(form.elements).filter(function (input) { return input.name === 'quantity' && input.form === form; });
    }
    function updatePrice(total, invalid) {
      var priceNode = root.querySelector('[data-bf-greenery-price]');
      var unitNode = root.querySelector('[data-bf-greenery-unit-price]');
      if (!priceNode || !unitNode) return;
      var priceText = invalid ? 'Check quantities' : total < 5 ? 'Choose 5+ bunches' : 'Updating price...';
      var unitText = invalid ? 'Use whole bunch quantities' : total < 5 ? 'Minimum 5 bunches total' : 'Your total will appear shortly';
      var table = form.querySelector('[data-bf-fresh-foliage-pricing-clone] table');
      if (!invalid && total >= 5 && table) {
        var headings = Array.from(table.querySelectorAll('thead th')).map(function (cell) { return cell.textContent.trim().toLowerCase(); });
        var priceIndex = headings.findIndex(function (text) { return /^(?:unit\s+)?price\b/.test(text); });
        var selected = null;
        if (priceIndex >= 0) {
          Array.from(table.querySelectorAll('tbody tr')).forEach(function (row) {
            var match = row.cells[0] && row.cells[0].textContent.match(/\d+/);
            var start = match ? Number(match[0]) : 0;
            if (start > 0 && total >= start && (!selected || start > selected.start)) selected = { row: row, start: start };
          });
        }
        if (selected && selected.row.cells[priceIndex]) {
          var cell = selected.row.cells[priceIndex].cloneNode(true);
          cell.querySelectorAll('s, del, .compare-at-price').forEach(function (node) { node.remove(); });
          var text = cell.textContent.trim().replace(/,/g, '');
          var amounts = text.match(/\d+(?:\.\d{1,2})?/g) || [];
          if (amounts.length === 1 && text.indexOf('%') === -1) {
            var cents = Math.round(Number(amounts[0]) * 100);
            var subtotal = cents * total;
            if (cents > 0 && Number.isSafeInteger(subtotal)) {
              var currency = root.dataset.currency || 'USD';
              var format = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency });
              priceText = format.format(subtotal / 100);
              unitText = format.format(cents / 100) + ' per bunch';
            }
          }
        }
      }
      if (priceNode.textContent !== priceText) priceNode.textContent = priceText;
      if (unitNode.textContent !== unitText) unitNode.textContent = unitText;
    }
    function sync() {
      if (syncing) return selection();
      syncing = true;
      var state = selection();
      var total = state.invalid ? 0 : state.total;
      var signature = state.rows.map(function (row) { return row.input.dataset.varietyId + ':' + row.quantity; }).join('|') + '|total:' + total;
      if (totalNode.textContent !== String(total)) totalNode.textContent = String(total);
      if (signature !== lastSignature || !properties.childElementCount) {
        lastSignature = signature;
        properties.replaceChildren();
        property('_bf_custom_greenery_box', 'true');
        property('_bf_greenery_box_id', window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
        property('Greenery selection', state.rows.map(function (row) { return row.input.dataset.variety + ': ' + row.quantity + (row.quantity === 1 ? ' bunch' : ' bunches'); }).join('; '));
        property('Total bunches', String(total));
      }
      Array.from(new Set(quantityControls().concat(Array.from(form.querySelectorAll('[data-bf-fresh-quantity-display], .waio_moq_qty .input_moq'))))).forEach(function (input) {
        if (input.value !== String(total)) {
          input.value = String(total);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.value = String(total);
        }
        if (input.matches('[data-bf-fresh-quantity-display]')) input.setAttribute('data-bf-quantity-editing', 'true');
      });
      quantityControls().forEach(function (input) { input.value = String(total); });
      updatePrice(total, !!state.invalid);
      syncing = false;
      return state;
    }
    function validate(event) {
      var state = sync();
      var message = state.invalid ? 'Enter a whole number of bunches, zero or more, for each greenery option.' : state.total < 5 ? 'Choose at least 5 bunches total to add your greenery box.' : '';
      var submittedQuantities = new FormData(form).getAll('quantity');
      if (!message && (!submittedQuantities.length || submittedQuantities.some(function (value) { return String(value) !== String(state.total); }))) {
        message = 'Your greenery quantity could not be updated. Please refresh the page and try again.';
      }
      error.textContent = message;
      error.hidden = !message;
      if (message) {
        if (event) { event.preventDefault(); event.stopImmediatePropagation(); }
        (state.invalid || inputs.find(function (input) { return !input.disabled; })).focus();
        return false;
      }
      return true;
    }
    root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-bf-greenery-count]')) return;
      sync();
      error.hidden = true;
    });
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-bf-greenery-count]')) sync();
    });
    form.addEventListener('submit', validate, true);
    form.addEventListener('ajaxProduct:added', function () { lastSignature = ''; sync(); });
    form.addEventListener('click', function (event) {
      if (event.target.closest('[type="submit"], [data-add-to-cart]')) validate(event);
    }, true);
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    });
    observer.observe(form, { childList: true, subtree: true, characterData: true });
    sync();
    form.dataset.bfGreeneryReady = 'true';
    var timer = setInterval(function () {
      if (!root.isConnected) { clearInterval(timer); observer.disconnect(); return; }
      sync();
    }, 600);
  }
  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-bf-greenery-box]').forEach(initialize);
  }
  initializeAll(document);
  document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
